import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchGeoWiseRevenueAnalysis } from "../../../services/accIqService";
import { FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST, fetchGeoWiseRevenueAnalysisFailure, fetchGeoWiseRevenueAnalysisSuccess } from "../actions/fetchGeoWiseRevenueAnalysisAction";


// Worker Saga
function* fetchGeoWiseRevenueAnalysisSaga() {
  try {
    const params = yield select(state=>state?.fetchGeoWiseRevenueAnalysisReducer?.payload);
    const {ticker} = params;
    const data = yield call(fetchGeoWiseRevenueAnalysis,ticker);

    yield put(fetchGeoWiseRevenueAnalysisSuccess(data));
  } catch (error) {
    yield put(fetchGeoWiseRevenueAnalysisFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchGeoWiseRevenueAnalysis() {
  yield takeLatest(FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST, fetchGeoWiseRevenueAnalysisSaga);
}
